import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../../atoms/button'
import { formSubmitIsDisabled } from '../../../../../utils/formUtils'
import { useTranslation } from '../../../../../context/translationProvider'
import { brandConfig } from '../../../../../config/brandConfig'
import { RegistrationCheckmarks } from '../../../../molecules/registrationCheckmarks'
import { useEventTracking } from '../../../../../context/eventTrackingProvider'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { Turnstile, useTurnstileOn } from '../../../../../hooks/useTurnstile'
import { 
  StyledTermsAndConditionsWrapper, 
  StyledTermsAndConditionsTitle,
  StyledTermsAndConditionsDescription,
  StyledTermsAndConditions,
  StyledBottomDiv
} from './styles'
const TermsAndConditionsStep = ({
  formProperties,
  onCompleteStep,
  isPage,
  loading,
  setToken
}) => {
  const { getValues, watch, formState: { errors } } = formProperties

  const { translate } = useTranslation()
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS } = useEventTracking()
  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false)
  const { captchaTurnstileOn } = useTurnstileOn()

  const getFieldsToWatch = () => {
    const defaultFields = [
      'tandc',
      'privacyPolicy',
      'belongHere',
    ]
    return defaultFields
  }

  useEffect(() => {
    watch(getFieldsToWatch())
  }, [])

  const IS_TERMS_AND_CONDITION_STEP_ENABLED = useFeatureIsOn(
    'fe_registration_terms_and_conditions_later_step'
  );

  const fieldsToWatch = getFieldsToWatch()

  const onCaptchaVerified = useCallback((data) => {
      setToken(data)
      setIsCaptchaPassed(true)
    }, [])
  
    const onCaptchaExpired = useCallback(() => {
      setToken(null)
      setIsCaptchaPassed(false)
    }, [])

  const completeTermsAndConditionsStep = () => {
      trackEvent(EVENT_NAMES.TERMS_AND_CONDITIONS_COMPLETED, {
        location: EVENT_LOCATIONS.REGISTER_START
      }, true)
      onCompleteStep()
  }

  const isDisabled = loading || 
    formSubmitIsDisabled(fieldsToWatch, getValues, errors) || 
    (!isCaptchaPassed && captchaTurnstileOn) 
            
  return (
    <>
      <StyledTermsAndConditionsWrapper>
        <StyledTermsAndConditionsTitle>
          {translate('registration.termsAndConditions.title')}
        </StyledTermsAndConditionsTitle>
        <StyledTermsAndConditionsDescription>
          {translate('registration.termsAndConditions.description')}
        </StyledTermsAndConditionsDescription>
        <StyledTermsAndConditions isPage={isPage}>
          <RegistrationCheckmarks formProperties={formProperties} /> 
        </StyledTermsAndConditions>
        <Turnstile 
          action="REGISTRATION"
          onCaptchaVerified={onCaptchaVerified}
          onCaptchaExpired={onCaptchaExpired}
        />
        <StyledBottomDiv>
          <Button
            id="nextBtn2"
            expand
            type="button"
            style={{
              fontSize: brandConfig.fonts.text.button.size.desktop,
            }}
            disabled={isDisabled}
            onClick={completeTermsAndConditionsStep}
            loading={loading}
            >
              {IS_TERMS_AND_CONDITION_STEP_ENABLED ? translate('common.register') : translate('register.next')}
            </Button>
          </StyledBottomDiv>
      </StyledTermsAndConditionsWrapper>
    </>
  )
}

TermsAndConditionsStep.propTypes = {
  formProperties: PropTypes.shape({
    register: PropTypes.func,
    getValues: PropTypes.func,
    setError: PropTypes.func,
    setValue: PropTypes.func,
    watch: PropTypes.func,
    formState: PropTypes.shape({ errors: PropTypes.object }),
  }),
  onCompleteStep: PropTypes.func,
  isPage: PropTypes.bool,
  loading: PropTypes.bool,
  setToken: PropTypes.func,
}

export { TermsAndConditionsStep }
